export default "__VITE_ASSET__COf1_H$1__"